<template>
<div class="wrap">
    <ul class="brand_list">

        <li v-for="(brand) in BrandItems" :key="`brand-select-${brand.id}`">
            <router-link :to="routeLink(brand.id)">
                <img class="wh100p box-sizing p-2" :src="brand.url">
            </router-link>
        </li>

    </ul>
</div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name:'BrandList',
    async created() {
        await this.$store.dispatch('GET_BRAND_LIST')
        this.setHeaderTitle();
        this.$store.commit('SHOW_ONLOAD');
    },
    computed: {
        ...mapState({
            BrandItems: state => state.brand.items,
        }),

        routeName() {
            return this.$route.name;
        }
    },
    methods: {
        setHeaderTitle() {
            if(this.routeName == 'BrandSelect')
                this.$store.state.headerTitle = '딜러사 둘러보기';
            else 
                this.$store.state.headerTitle = '브랜드 선택';
        },

        routeLink(id) {

            if(this.routeName == 'BrandSelect')
                return `/dealerList/${id}`;
                
            else 
                return `/vehicleList/${id}`;    
        }
    },
}
</script>

<style scoped>

</style>